const x = (t, e, n) => {
  t.selectionStart = e, t.selectionEnd = n;
}, p = (t) => {
  let e = 0, n = 0;
  return t.selectionStart && t.selectionEnd && (e = t.selectionStart, n = t.selectionEnd), {
    start: e,
    end: n,
    length: n - e
  };
}, l = (t) => t === "ru-RU" ? { valid: ",", invalid: "." } : { valid: ".", invalid: "," }, a = (t, e) => t.replaceAll(e.invalid, e.valid).replace(/[^0-9,.]/g, "").split(e.valid), d = (t) => {
  const e = /(\d+)(\d{3})/;
  for (; e.test(t); )
    t = t.replace(e, "$1 $2");
  return t;
}, u = {
  toInt: (t, e) => {
    if (!t)
      return t;
    const n = l(e), r = a(t, n);
    return d(r[0]);
  },
  toDecimal: (t, e, n) => {
    if (!t)
      return t;
    const r = l(e), o = n ? r.valid + "00" : "", c = a(t, r), s = d(c[0]), i = c.length > 1 ? r.valid + c[1] : o;
    return s + i;
  },
  toPrice: (t, e, n) => {
    if (!t)
      return t;
    const r = l(e), o = n ? r.valid + "00" : "", c = a(t, r), s = d(c[0]), i = c.length > 1 ? r.valid + c[1].slice(0, 2) : o;
    return s + i;
  },
  toUpperFirst: (t) => t && t.charAt(0).toUpperCase() + t.slice(1)
};
export {
  u as default,
  p as getInputSelection,
  x as setInputSelection
};
